const isSome = (value) => value !== undefined && value !== null;
const isNone = (value) => value === undefined || value === null;
function validateFinancialStatementRequiredFields(val, ctx) {
    const { date, preparationMethod, balanceSheet, incomeStatement } = val;
    const hasAtLeastOneField = (balanceSheet && Object.values(balanceSheet).some(isSome)) ||
        (incomeStatement && Object.values(incomeStatement).some(isSome));
    if (!date && hasAtLeastOneField) {
        ctx.addIssue({
            code: "custom",
            message: "Required",
            input: val,
            path: ["date"],
        });
    }
    if (!preparationMethod && (hasAtLeastOneField || isSome(date))) {
        ctx.addIssue({
            code: "custom",
            message: "Required",
            input: val,
            path: ["preparationMethod"],
        });
    }
}
function validateWipDateRequired(val, ctx) {
    const { date, ...otherFields } = val;
    const hasWipValues = Object.values(otherFields).some(isSome);
    if (hasWipValues && isNone(date)) {
        ctx.addIssue({
            code: "custom",
            message: "Required",
            input: val,
            path: ["date"],
        });
    }
}

export { validateFinancialStatementRequiredFields, validateWipDateRequired };
